import React, { useState } from 'react';
import axios from 'axios';

const API = 'https://buzzinguniverse.com/backend/api';

const PAGE_REPORT_REASONS = [
    'Spam',
    'Fake profile or page',
    'Pretending to be someone else',
    'Harassment or bullying',
    'Hate speech',
    'Nudity or sexual content',
    'Violence or dangerous content',
    'Scam or fraud',
    'Something else',
];

const POST_REPORT_REASONS = [
    'Spam',
    'False information',
    'Harassment or bullying',
    'Hate speech',
    'Nudity or sexual content',
    'Violence or dangerous content',
    'Scam or fraud',
    'Something else',
];

/**
 * Report dialog for a profile, a group/company page or a post.
 *  - targetType: 'user' | 'group' | 'company' | 'post'
 *  - targetId: what is being reported
 *  - targetName: shown in the title (not used for posts)
 *  - onReported: called once the report is saved
 */
const ReportModal = ({ targetType, targetId, targetName, auth, onClose, onReported }) => {
    const isPost = targetType === 'post';
    const reasons = isPost ? POST_REPORT_REASONS : PAGE_REPORT_REASONS;
    const [reason, setReason] = useState('');
    const [details, setDetails] = useState('');
    const [sending, setSending] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        if (!reason) return;
        setSending(true);
        setError('');
        try {
            const res = await axios.post(`${API}/report-entity`,
                { reporter_id: auth?.id, target_type: targetType, target_id: targetId, reason, details },
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            if (res.data.status) {
                setDone(true);
                onReported && onReported();
            } else setError(res.data.error || 'Could not send the report. Please try again.');
        } catch (err) {
            setError('Could not send the report. Please try again.');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="page-actions-backdrop" onClick={onClose}>
            <div className="page-actions-modal" onClick={(e) => e.stopPropagation()}>
                <div className="page-actions-modal-head">
                    <h5>{isPost ? 'Report post' : `Report ${targetName}`}</h5>
                    <span className="page-actions-close" onClick={onClose}>&times;</span>
                </div>
                {done ? (
                    <div className="page-actions-done">
                        <i className="fas fa-check-circle" />
                        <p>Thanks for letting us know. Our team will review this report.{isPost && " We've hidden this post from your feed."}</p>
                        <button type="button" className="page-actions-primary" onClick={onClose}>Done</button>
                    </div>
                ) : (
                    <form onSubmit={submit}>
                        <p className="page-actions-hint">Why are you reporting this {targetType === 'user' ? 'profile' : targetType}?</p>
                        <div className="page-actions-reasons">
                            {reasons.map((r) => (
                                <label key={r} className={reason === r ? 'active' : ''}>
                                    <input type="radio" name="report-reason" value={r} checked={reason === r} onChange={() => setReason(r)} />
                                    {r}
                                </label>
                            ))}
                        </div>
                        <textarea placeholder="Add more details (optional)" value={details} maxLength={2000} onChange={(e) => setDetails(e.target.value)} />
                        {error && <p className="page-actions-error">{error}</p>}
                        <button type="submit" className="page-actions-primary" disabled={!reason || sending}>
                            {sending ? 'Sending...' : 'Submit Report'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ReportModal;
